import React from 'react'

import { Image } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../lib/analytics'
import { FitModel as Props } from '../../../../types/graphql'

import { Body, Figure, Name, Stat, TextWrap } from './styles'

export const FitModelTile: React.FC<Props & { isActive?: boolean; onClick?: () => void }> = ({
  height,
  images,
  isActive,
  name,
  onClick,
  pantsSize,
  topSize,
}) => {
  const { fitModel: strings } = useTranslation()
  const ariaSelected = onClick && { 'aria-selected': isActive }
  return (
    <Body
      {...{ isActive, onClick }}
      {...ariaSelected}
      as={onClick ? 'button' : 'div'}
      {...trackEvent({
        category: 'model selector',
        action: 'select model',
        label: name,
      })}
    >
      <Figure>
        <Image alt={name} src={images[0]} />
      </Figure>
      <TextWrap>
        <Name>{name}</Name>
        <Stat>
          {strings.topSize}: <b>{topSize}</b>
        </Stat>
        <Stat>
          {strings.pantsSize}: <b>{pantsSize}</b>
        </Stat>
        <Stat>
          {strings.height}: <b>{height}</b>
        </Stat>
      </TextWrap>
    </Body>
  )
}
